import { Component } from '@angular/core';

@Component({
  selector: 'app-promo-ticker',
  templateUrl: './promo-ticker.component.html',
  styleUrls: ['./promo-ticker.component.css'],
  standalone: false
})
export class PromoTickerComponent {
  readonly items = [
    {
      pair: 'NEW',
      text: 'Welcome bonus just dropped — $5 Lucky Bucks to snag your first seats.',
      tag: 'ON THE HOUSE'
    },
    {
      pair: 'LIVE',
      text: 'New players are in — claim $5 Lucky Bucks and take a seat tonight.',
      tag: 'FIRST SEATS'
    },
    {
      pair: 'DROP',
      text: 'Sign up and the house covers $5 toward your opening play.',
      tag: 'LUCKY BUCKS'
    }
  ];
  readonly copies = [0, 1];
  readonly srText = this.items.map(item => item.text).join(' ');
}
